const pgcetmbaEnglishLanguage = [
  {
    id: 61,
    question: "He is Steve, whose father is in the army. Identify the relative pronoun used in the given sentence.",
    options: ["A. He", "B. father", "C. army", "D. whose"],
    answer: "D"
  },
  {
    id: 62,
    question: "Direction: Point out the figure of speech used in the sentence given below. Sceptre and crown must tumble down, and in dust be equal made with the poor crooked scythe and spade.",
    options: ["A. Irony", "B. Apostrophe", "C. Metonymy", "D. Synecdoche"],
    answer: "C"
  },
  {
    id: 63,
    question: "Direction: Choose the correct verb in given sentence. The bus started moving while she ______ it.",
    options: ["A. boarding", "B. was boarding", "C. board", "D. is boarding"],
    answer: "B"
  },
  {
    id: 64,
    question: "Direction: Select the most appropriate meaning of the underlined idiom in the given sentence. Pradeep was so tired that he hit the sack as soon as possible.",
    options: ["A. Left work", "B. Went to bed", "C. Accepted defeat", "D. Kicked the sack"],
    answer: "B"
  },
  {
    id: 65,
    question: "Find the correctly spelled word.",
    options: ["A. Cannibale", "B. Cannible", "C. Cannibal", "D. Cannebal"],
    answer: "C"
  },
  {
    id: 66,
    question: "Direction: Fill in the blank with the correct preposition. I'm familiar ______ your work.",
    options: ["A. on", "B. about", "C. with", "D. to"],
    answer: "C"
  },
  {
    id: 67,
    question: "Direction: In the following question a part of the sentence is bold. Below are given alternatives to the bold part at (A), (B), and (C) which may improve the sentence. Choose the correct alternative. In the case of no improvement, choose (D) as your answer. Practically every part of the coconut tree is used by man.",
    options: ["A. Each", "B. All", "C. Most", "D. No improvement"],
    answer: "D"
  },
  {
    id: 68,
    question: "Direction: A sentence has given below, with some errors. Find the best option which is error-free. The councillor has not and will not file his nomination for re-election.",
    options: [
      "A. The councillor has not and will not file his nomination for re-election.",
      "B. The councillor has not filed, nor he will file his nomination for re-election.",
      "C. The councillor has not file and will not file his nomination for re-election.",
      "D. The councillor has not filed and will not file his nomination for re-election."
    ],
    answer: "D"
  },
  {
    id: 69,
    question: "Direction: Select the correct passive form of the given sentence. Nobody will help you if you are rude.",
    options: [
      "A. You will not been helped by nobody if you are rude.",
      "B. You are not being helped by anybody if you are rude.",
      "C. You are not helped by anybody if you are rude.",
      "D. You will not be helped by anybody if you are rude."
    ],
    answer: "D"
  },
  {
    id: 70,
    question: "Direction: Select the most appropriate option to substitute the underlined segment in the given sentence. If there is no need to substitute it, select 'No substitution'. Small desert animals burrow underground across the days and come out only at night.",
    options: ["A. within the days", "B. between days", "C. No substitution", "D. during the day"],
    answer: "D"
  },
  {
    id: 71,
    question: "Direction: Select the word which means the same as the group of words given. A person who does not believe in God.",
    options: ["A. Spiritualist", "B. Atheist", "C. Hypocrite", "D. Sceptic"],
    answer: "B"
  },
  {
    id: 72,
    question: "Direction: Select the word which means the same as the group of words given. The fear of water.",
    options: ["A. Hydrophobia", "B. Claustrophobia", "C. Pyrophobia", "D. Autophobia"],
    answer: "A"
  },
  {
    id: 73,
    question: "Direction: Select the word which means the same as the group of words given. A distinguished conductor or performer of classical music.",
    options: ["A. Novice", "B. Maestro", "C. Layman", "D. Amateur"],
    answer: "B"
  },
  {
    id: 74,
    question: "Select the correct suffix to change the form of the given word 'Accomplish'.",
    options: ["A. ment", "B. ly", "C. ness", "D. ful"],
    answer: "A"
  },
  {
    id: 75,
    question: "Select the correct suffix to get the meaningful word of 'Religi'.",
    options: ["A. less", "B. ous", "C. wise", "D. able"],
    answer: "B"
  },
  {
    id: 76,
    question: "Select the most appropriate synonym of the word 'Revamp'.",
    options: ["A. Repeat", "B. Retreat", "C. Restructure", "D. Retrial"],
    answer: "C"
  },
  {
    id: 77,
    question: "Direction: Select the most appropriate antonym of the given word. Lack-lustre",
    options: ["A. Boring", "B. Unimaginative", "C. Routine", "D. Radiant"],
    answer: "D"
  },
  {
    id: 78,
    question: "Direction: Select the most appropriate antonym of the given word. Lucrative",
    options: ["A. Smooth", "B. Worthwhile", "C. Unprofitable", "D. Well-paid"],
    answer: "C"
  },
  {
    id: 79,
    question: "Select the most appropriate synonym of the given word. Erstwhile",
    options: ["A. Former", "B. Uncertain", "C. False", "D. Present"],
    answer: "A"
  },
  {
    id: 80,
    question: "Direction: Choose the option that fills in the blank with the most appropriate verb form. By the end of this month, I ______ three more chapters for this book.",
    options: ["A. will have written", "B. wrote", "C. will write", "D. have written"],
    answer: "A"
  }
];
export default pgcetmbaEnglishLanguage;